/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoginRequestDeviceInfo } from './LoginRequestDeviceInfo';
import {
    LoginRequestDeviceInfoFromJSON,
    LoginRequestDeviceInfoFromJSONTyped,
    LoginRequestDeviceInfoToJSON,
    LoginRequestDeviceInfoToJSONTyped,
} from './LoginRequestDeviceInfo';

/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    pin: string;
    /**
     * 
     * @type {LoginRequestDeviceInfo}
     * @memberof LoginRequest
     */
    deviceInfo: LoginRequestDeviceInfo;
}

/**
 * Check if a given object implements the LoginRequest interface.
 */
export function instanceOfLoginRequest(value: object): value is LoginRequest {
    if (!('pin' in value) || value['pin'] === undefined) return false;
    if (!('deviceInfo' in value) || value['deviceInfo'] === undefined) return false;
    return true;
}

export function LoginRequestFromJSON(json: any): LoginRequest {
    return LoginRequestFromJSONTyped(json, false);
}

export function LoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pin': json['pin'],
        'deviceInfo': LoginRequestDeviceInfoFromJSON(json['deviceInfo']),
    };
}

export function LoginRequestToJSON(json: any): LoginRequest {
    return LoginRequestToJSONTyped(json, false);
}

export function LoginRequestToJSONTyped(value?: LoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pin': value['pin'],
        'deviceInfo': LoginRequestDeviceInfoToJSON(value['deviceInfo']),
    };
}

